import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { LoginService } from '../../../app/core/services/login.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: any = '';
  password: string = '';
  errorMsg: any = '';
  userDetails: any;
  constructor(private router: Router, private loginservice: LoginService) { }

  async ngOnInit() {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('loginType');
    localStorage.removeItem('userNameWithoutSSO');
    localStorage.removeItem('isUserWithoutSSO');
    localStorage.removeItem('NTID');
  }

  async onSSOLogin() {
    try {
      const result = await this.loginservice.loginWithSSO();
      console.log('SSO login successful:', result);
      this.username = result.account.name;
      this.loginservice.setUsername(this.username);
      localStorage.setItem('isLoggedIn', 'true');
      this.loginservice.handlePostSSOLogin(result.account);
      this.router.navigate(['/timesheet/timesheet-n']);
      // localStorage.setItem('loginType', 'SSO');
    } catch (error) {
      3
      console.error('SSO login failed:', error);
    }
  }

  onLogin() {

    this.loginservice.login(this.username, this.password).subscribe({
      next: (res: { success: any; message: any }) => {

        if (res.success) {

          console.log(res);
          this.loginservice.getUsername(this.username).subscribe({
            next: (res) => {
              console.log("User details:", res);
              this.userDetails = res.data;
              this.loginservice.setUsername(this.userDetails.user_Name);
              localStorage.setItem('userNameWithoutSSO', this.userDetails.user_Name);
              localStorage.setItem('emailWithoutSSO', this.userDetails.email_Address);
              localStorage.setItem('NTID', this.userDetails.ntid);
            },
            error: (err) => {
              console.error("Error fetching user:", err);
            }
          });


          // Save info to localStorage if needed

          localStorage.setItem('isLoggedIn', 'true');
          this.router.navigate(['/timesheet/timesheet-n']);
          //alert('Login successful!');
        } else if (!res.success && res.message == "Invalid password") {
          console.log(res);
          this.errorMsg = "Incorrect username or password";
        } else if (!res.success && res.message == "User does not exist") {
          this.errorMsg = "User does not exist";
        }
        else {
          this.errorMsg = res.message;
          console.log(this.errorMsg, res);
          this.router.navigate(['/changePassword'], { queryParams: { username: this.username } });
        }
      },
      error: (err: any) => {
        console.error(err);
        this.errorMsg = 'Server error';
      }
    });
  }
}

